import { render, staticRenderFns } from "./LegalAtlasModal.vue?vue&type=template&id=c01d0358&scoped=true&"
import script from "./LegalAtlasModal.vue?vue&type=script&lang=js&"
export * from "./LegalAtlasModal.vue?vue&type=script&lang=js&"
import style0 from "./LegalAtlasModal.vue?vue&type=style&index=0&id=c01d0358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01d0358",
  null
  
)

export default component.exports